import { openBlock as o, createElementBlock as n, createElementVNode as r } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
};
function l(c, e) {
  return o(), n("svg", t, e[0] || (e[0] = [
    r("path", { d: "M16.22 2.663a1.47 1.47 0 0 0-1.09 0L8.87 5.167c-.35.14-.74.14-1.09 0L1.982 2.848a.735.735 0 0 0-1.008.686V17.62c0 .601.366 1.142.924 1.365l5.88 2.352c.35.14.742.14 1.092 0l6.258-2.504c.35-.14.741-.14 1.092 0l5.796 2.315a.735.735 0 0 0 1.008-.686V6.38a1.47 1.47 0 0 0-.924-1.365ZM8.325 5.272v16.17m7.35-18.884v16.17" }, null, -1)
  ]));
}
const s = { render: l };
export {
  s as default,
  l as render
};
